import { z } from "zod";
import { BaseAnalyticsEvent } from "./base";
export const Chart_View = BaseAnalyticsEvent.extend({
    name: z.literal("Chart_View")
});
export const Chart_Download = BaseAnalyticsEvent.extend({
    name: z.literal("Chart_Download")
});
export const Chart_TimeframeChange = BaseAnalyticsEvent.extend({
    name: z.literal("Chart_TimeframeChange"),
    properties: z.object({
        timeframe: z.enum([
            "day",
            "week",
            "month",
            "3m",
            "6m",
            "year"
        ])
    })
});
